(function () {
  const SECTION_SELECTOR = '[data-reviews-carousel]';

  const getGap = (element) => {
    const computed = window.getComputedStyle(element);
    const columnGap = Number.parseFloat(computed.columnGap);
    if (!Number.isNaN(columnGap)) {
      return columnGap;
    }

    const gap = Number.parseFloat(computed.gap);
    return Number.isNaN(gap) ? 0 : gap;
  };

  const setupSection = (section) => {
    if (section.dataset.reviewsCarouselReady === 'true') {
      return;
    }

    const track = section.querySelector('[data-reviews-track]');
    const cards = Array.from(section.querySelectorAll('[data-review-card]'));
    const prevButton = section.querySelector('[data-reviews-prev]');
    const nextButton = section.querySelector('[data-reviews-next]');

    if (!track || cards.length === 0) {
      return;
    }

    section.dataset.reviewsCarouselReady = 'true';

    let resizeRaf = null;

    const visibleCards = () => cards.filter((card) => !card.hidden);

    const getStep = () => {
      const firstVisibleCard = visibleCards()[0];
      if (!firstVisibleCard) {
        return track.clientWidth;
      }

      return firstVisibleCard.getBoundingClientRect().width + getGap(track);
    };

    const isAtStart = () => track.scrollLeft <= 2;
    const isAtEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

    const updateNavigation = () => {
      const hasOverflow = track.scrollWidth > track.clientWidth + 1;
      const hasCards = visibleCards().length > 0;
      const disablePrev = !hasOverflow || !hasCards || isAtStart();
      const disableNext = !hasOverflow || !hasCards || isAtEnd();

      if (prevButton) {
        prevButton.disabled = disablePrev;
      }

      if (nextButton) {
        nextButton.disabled = disableNext;
      }
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    let animationFrame = null;
    track.addEventListener(
      'scroll',
      () => {
        if (animationFrame) {
          return;
        }

        animationFrame = window.requestAnimationFrame(() => {
          updateNavigation();
          animationFrame = null;
        });
      },
      { passive: true }
    );

    const onResize = () => {
      if (resizeRaf) {
        window.cancelAnimationFrame(resizeRaf);
      }

      resizeRaf = window.requestAnimationFrame(() => {
        updateNavigation();
        resizeRaf = null;
      });
    };

    window.addEventListener('resize', onResize);
    updateNavigation();
  };

  const initialize = (root) => {
    const scope = root || document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(setupSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document));
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section) {
      return;
    }

    if (section.matches && section.matches(SECTION_SELECTOR)) {
      setupSection(section);
      return;
    }

    initialize(section);
  });
})();
